if (!customElements.get('dyld-countdown')) {
  customElements.define('dyld-countdown', class extends HTMLElement {
    connectedCallback() {
      this.timer = this.querySelector('[data-timer]');
      this.status = this.querySelector('[data-status]');
      this.progress = this.querySelector('[data-progress]');
      this.bar = this.querySelector('[data-bar]');
      this.percent = this.querySelector('[data-percent]');
      this.offer = this.querySelector('[data-offer]');
      this.parts = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector(`[data-${unit}]`));
      const parse = value => /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?(Z|[+-]\d{2}:\d{2})$/.test(value || '') ? Date.parse(value) : NaN;
      this.start = parse(this.dataset.start);
      this.end = parse(this.dataset.end);
      clearInterval(this.interval);
      this.timer.hidden = true;
      this.progress.hidden = true;
      this.status.hidden = false;
      this.status.textContent = "Dates to be announced";
      if (!Number.isFinite(this.end) || (this.dataset.start && (!Number.isFinite(this.start) || this.start >= this.end))) return;
      this.onVisibility = () => {
        clearInterval(this.interval);
        if (!document.hidden && this.update()) this.interval = setInterval(() => this.update(), 1000);
      };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onVisibility();
    }
    update() {
      const now = Date.now();
      const upcoming = Number.isFinite(this.start) && now < this.start;
      const ended = now >= this.end;
      if (this.offer) this.offer.hidden = ended;
      this.timer.hidden = ended;
      this.timer.setAttribute("aria-label", upcoming ? "Time until launch" : "Time remaining");
      this.status.hidden = !ended;
      const message = ended ? this.dataset.ended : '';
      if (this.status.textContent !== message) this.status.textContent = message;
      this.progress.hidden = ended || !Number.isFinite(this.start);
      if (ended) { clearInterval(this.interval); return false; }
      const seconds = Math.max(0, Math.ceil(((upcoming ? this.start : this.end) - now) / 1000));
      const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
      this.parts.forEach((part, i) => {
        const value = String(values[i]).padStart(2, '0');
        if (part.textContent !== value) part.textContent = value;
      });
      if (!this.progress.hidden) {
        const remaining = Math.max(0, Math.min(100, (this.end - now) / (this.end - this.start) * 100));
        if (this.bar.value !== Math.ceil(remaining)) this.bar.value = Math.ceil(remaining);
        const label = `${Math.ceil(remaining)}%`;
        if (this.percent.textContent !== label) this.percent.textContent = label;
      }
      return true;
    }
    disconnectedCallback() { clearInterval(this.interval); document.removeEventListener('visibilitychange', this.onVisibility); }
  });
}
